import { useEffect } from 'react';

const findScrollContainer = (el: HTMLElement): HTMLElement | null => {
  let parent = el.parentElement;

  while (parent && parent !== document.body) {
    const styles = window.getComputedStyle(parent);

    if (
      styles.overflowY === 'auto' ||
      (parent.classList.contains('overflow-y-auto') &&
        parent.scrollHeight > parent.clientHeight)
    ) {
      return parent;
    }

    parent = parent.parentElement;
  }

  return document.querySelector('main') || document.documentElement;
};

export function useThreeDStockShowFiltersLayout(
  stickyElement: React.RefObject<HTMLElement>
) {
  useEffect(() => {
    const element = stickyElement.current;
    if (!element) return;

    const scrollContainer = findScrollContainer(element);
    if (!scrollContainer) return;

    function updateStickyPosition() {
      const currentScroll = scrollContainer.scrollTop;

      const multiplier = currentScroll > 35 ? 0.98 : 0.93;

      const containerHeight = scrollContainer.clientHeight * multiplier;

      element.style.height = `${containerHeight}px`;
    }

    scrollContainer.addEventListener('scroll', updateStickyPosition, {
      passive: true
    });
    window.addEventListener('resize', updateStickyPosition, { passive: true });

    setTimeout(updateStickyPosition, 100);

    return () => {
      scrollContainer.removeEventListener('scroll', updateStickyPosition);
      window.removeEventListener('resize', updateStickyPosition);
    };
  }, [stickyElement]);
}

export default useThreeDStockShowFiltersLayout;
